import React from "react";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-16">
          <span className="font-body text-xs tracking-luxe uppercase text-[#B0603F]">Témoignages</span>
          <h2 className="font-serif-display text-5xl md:text-7xl font-light text-[#3A302A] mt-3">
            Elles & ils en <span className="font-script text-[#B0603F]">parlent</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 90}>
              <div className="h-full bg-[#FAF5EF] border border-[#E7D8C6] rounded-3xl p-8 hover:shadow-[0_28px_60px_-30px_rgba(58,48,42,0.4)] transition-shadow duration-500 flex flex-col">
                <Quote size={34} className="text-[#E7D8C6]" fill="currentColor" />
                <p className="font-serif-display italic text-xl text-[#3A302A] leading-relaxed mt-4 flex-1">
                  {t.text}
                </p>
                <div className="flex items-center gap-1 mt-6 text-[#B0603F]">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} size={15} fill="currentColor" />
                  ))}
                </div>
                <div className="mt-4 pt-4 border-t border-[#E7D8C6]">
                  <div className="font-body font-medium text-[#3A302A]">{t.name}</div>
                  <div className="font-body text-xs tracking-wide-2 uppercase text-[#6B5D53] mt-0.5">
                    {t.role}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
